<div class="subscribe-page-main-container">
  <div class="subscribe-page-content-container">
    <p class="disclaimer">* Indicates required field</p>

    <form class="form" #form="ngForm">
      <newsletter-subscriber-details
        [details]="subscriptionRequest.subscriberDetails"
        [serverError]="serverError$ | async"
        [serverErrorEmail]="serverErrorEmail$ | async"
        (detailsChange)="subscriptionRequest.subscriberDetails = $event"
      ></newsletter-subscriber-details>
      <newsletter-subscription-topics
        [topics]="subscriptionRequest.topics"
        (topicsChange)="subscriptionRequest.topics = $event"
      ></newsletter-subscription-topics>

      <div *ngIf="!hasAtLeastOneTopicSelected" class="no-topic-error-message">
        Newsletter selection is required
      </div>

      <div class="btn-parent">
        <button type="button" class="secondary-button" (click)="onSubmit(form)">
          SUBMIT
        </button>
      </div>

      <p class="disclaimer">
        <br>By subscribing to our insights and providing your information, you consent to receive marketing communications from Spencer Stuart and accept the terms in our <a href="https://www.spencerstuart.com/privacy-policy" target="_blank">Spencer Stuart Privacy Policy</a>.
      </p>

      <div class="overlay" *ngIf="isLoading$ | async">
        <div class="spinner"></div>
      </div>
    </form>
  </div>
</div>
